const CustomerType = {
  Transient: "transient",
  KeyAccount: "key-account",
};

export default CustomerType;
